export class Grid {
    
    public loadingLastMovements : boolean;
    public loadingLastCounts : boolean;
    
    public lastMovements : any[];
    public lastCounts : any[];
    
    setMovements(data : any[]) {
        this.lastMovements = new Array();
        for (let d of data) {
            this.lastMovements.push(this.getData(d));
        }
    };
    
    setCounts(data: any[]) {
        this.lastCounts = new Array();
        for (let d of data) {
            this.lastCounts.push(this.getData(d));
        }
    };
    
    getData(data : any) {
        return {
            locationId : data.locationId,
            locationName: data.locationName,
            createdDate : data.createdDate,
            full : this.getQuantity('F',data),
            used : this.getQuantity('U',data),
            empty: this.getQuantity('E',data) 
        }
    };
    
    getQuantity(status : string, data : any) {
        for (let sq of data.statusQuantity) {
            if (sq.concept == status) {
                return sq.value;    
            }
        }
        return 0;
    };
}
